export const LEGAL_WARNINGS = {
    PLEDGE: "Обнаружены сведения о нахождении в залоге",
    REGISTRATION: "Обнаружены ограничения на регистрационные действия",
    STEALING: "Обнаружены сведения о нахождении в розыске"
};